import { render, staticRenderFns } from "./Conversations.vue?vue&type=template&id=108e4ea6&scoped=true&"
import script from "./Conversations.vue?vue&type=script&lang=ts&"
export * from "./Conversations.vue?vue&type=script&lang=ts&"
import style0 from "./Conversations.vue?vue&type=style&index=0&id=108e4ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e4ea6",
  null
  
)

export default component.exports